/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
/**
 * To modify the labels and text displayed, create a new instance of MdPaginatorIntl and
 * include it in a custom provider
 */
export class MdPaginatorIntl {
/**
 * Stream that emits whenever the labels here are changed. Use this to notify
 * components if the labels have changed after initialization.
 */
changes: Subject<void> = new Subject<void>();
/**
 * A label for the page size selector.
 */
itemsPerPageLabel = 'Items per page:';
/**
 * A label for the button that increments the current page.
 */
nextPageLabel = 'Next page';
/**
 * A label for the button that decrements the current page.
 */
previousPageLabel = 'Previous page';
/**
 * A label for the range of items within the current page and the length of the whole list.
 */
getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length == 0 || pageSize == 0) { return `0 of ${length}`; }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} of ${length}`;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdPaginatorIntl_tsickle_Closure_declarations() {
/** @type {?} */
MdPaginatorIntl.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdPaginatorIntl.ctorParameters;
/**
 * Stream that emits whenever the labels here are changed. Use this to notify
 * components if the labels have changed after initialization.
 * @type {?}
 */
MdPaginatorIntl.prototype.changes;
/**
 * A label for the page size selector.
 * @type {?}
 */
MdPaginatorIntl.prototype.itemsPerPageLabel;
/**
 * A label for the button that increments the current page.
 * @type {?}
 */
MdPaginatorIntl.prototype.nextPageLabel;
/**
 * A label for the button that decrements the current page.
 * @type {?}
 */
MdPaginatorIntl.prototype.previousPageLabel;
/**
 * A label for the range of items within the current page and the length of the whole list.
 * @type {?}
 */
MdPaginatorIntl.prototype.getRangeLabel;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
